import { AMONTE } from '@/configuration/gabed/dispositif/dispositifPublicitaire';
import genererDispositifTechnique from '@/services/gabed/emplacement/generer/genererDispositifTechnique';

export default function genererDispositifPublicitaire() {
  return {
    code: '',
    proprietaire: true,
    etat: AMONTE,
    dateMontage: null,
    dateDemontage: null,
    actif: true,
    adresse: {
      ville: '',
      intitule1: '',
      intitule2: '',
      intitule3: '',
      adresse1: '',
      adresse2: '',
      adresse3: '',
      codePostal: '',
      pays: '',
      latitude: 0,
      longitude: 0,
      departement: '',
      agglomeration: '',
      codeInsee: '',
    },
    iot: '',
    PDLElectricite: '',
    emplacementId: '',
    dispositifSupportId: null,
    dispositifTypeId: null,
    tiersId: null,
    commentaire: null,
    natureSol: null,
    dispositifTechnique: genererDispositifTechnique(),
    dispositifAccessoires: [],
    arretBus: '',
    codeTimeo: '',
    avecCaissonPub: false,
    nomenclatureTypeId: null,
    nomenclature: {},
    tags: [],
  };
}
